import { useStore } from 'effector-react'

import {
  $totalCountOfTraders,
  getTraders,
  tradersListMounted,
  $traders,
} from './model'
import { TradersRequest } from './types'

export const useTradersList = () => {
  const traders = useStore($traders)
  const loading = useStore(getTraders.pending)
  const totalCountOfTraders = useStore($totalCountOfTraders)

  const onChangeTradersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
  }: TradersRequest) => {
    tradersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
    })
  }

  return {
    traders,
    totalCountOfTraders,
    loading,
    onChangeTradersList,
  }
}
